import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { SearchConditionTags } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/SearchConditionTags';
import { FilterModal } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/FilterModal';
import { MonthlyAnalysis } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/MonthlyAnalysis';
import { AmountByTeam } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/AmountByTeam';
import { AmountByOrder } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/AmountByOrder';
import { AmountByBusinessPartner } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/AmountByBusinessPartner';
import { AmountByUser } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/AmountByUser';
import { CsvExport } from '@/features/w/[identifier]/dashboard/purchase_orders/{components}/CsvExport';
import { useIntercomGuide } from '@/hooks/useIntercomGuide';

export const PurchaseOrdersDashboard = () => {
  const { setTitle, setBreadcrumbs } = useNavState();

  useEffect(() => setTitle('費用ボード'), []);
  useEffect(() => setBreadcrumbs([]), []);

  useIntercomGuide();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <button className="btn btn-icon-only btn-dark mx-2" data-bs-toggle="modal" data-bs-target="#modal-filter">
            <i className="fas fa-filter"></i>
          </button>
          <CsvExport />
        </div>

        <SearchConditionTags />

        <FilterModal />

        <MonthlyAnalysis />

        <AmountByTeam />

        <div className={'row'}>
          <AmountByOrder />
          <AmountByBusinessPartner />
          <AmountByUser />
        </div>
      </div>
    </WorkspaceLayout>
  );
};
